import { Exchange } from 'grts-utils/types/Exchange';

export enum Tabs {
  ManualDistribution = 'Manual Distribution',
  DepositDistribution = 'Deposit Distribution',
}

export type DistributionEntry = {
  subscriptionId: number;
  botFriendlyName: string;
  baseAsset: string;
  quoteAsset: string;
  exchange: Exchange;
  latestPrice: number;
  latestOrderType: 'BUY' | 'SELL' | null;
  originalPercentage: number;
  originalTotalBalance: number;
  originalStableBalance: number;
  originalAssetBalance: number;
  currentPercentage: number;
  currentTotalBalance: number;
  currentStableBalance: number;
  currentAssetBalance: number;
  isLocked: boolean;
  isDisabled: boolean;
};

export type DepositEntry = {
  subscriptionId: number;
  botFriendlyName: string;
  baseAsset: string;
  quoteAsset: string;
  exchange: Exchange;
  currentStableBalance: number;
  currentTotalBalance: number;
  depositAmount: number;
  depositPercentage: number;
  isLocked: boolean;
};
